import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { FingerprintService } from './fingerprint.service';

@Injectable()
export class HttpUtilService {

  constructor(private http: HttpClient,
    private fingerPrintService: FingerprintService) { }

  headers() {
    let httpHeaders: HttpHeaders = new HttpHeaders();

    if (sessionStorage['token']) {
      httpHeaders = httpHeaders.set(
        'Content-Type',
        'application/json');

      httpHeaders = httpHeaders.set(
        'Authorization',
        'Bearer ' + sessionStorage['token']
      );
    }

    return { headers: httpHeaders };
  }

  async headersWithTokenMaquina(inscricao) {
    let httpHeaders: HttpHeaders = new HttpHeaders();
    if (sessionStorage['tokenCadMaquinaApi']) {
      httpHeaders = httpHeaders.set(
        'Content-Type',
        'application/json');

      httpHeaders = httpHeaders.set(
        'Authorization',
        'Bearer ' + sessionStorage['tokenCadMaquinaApi']
      );
    }
    if (localStorage[inscricao]) {
      const finger = await this.fingerPrintService.identify(inscricao);
      httpHeaders = httpHeaders.set(
        'tokenMaquina', JSON.stringify(finger));
    }
    return { headers: httpHeaders };
  }

  headersWithParams(params2: URLSearchParams, parameterName: string) {
    let httpHeaders: HttpHeaders = new HttpHeaders();

    if (sessionStorage['token']) {
      httpHeaders = httpHeaders.set(
        'Content-Type',
        'application/json');

      httpHeaders = httpHeaders.set(
        'Authorization',
        'Bearer ' + sessionStorage['token']
      );
    }
    const params = new URLSearchParams();
    params.append('codigoSerial', '0000000000000000000000004799F650ACDD3C87');
    return params === undefined ? { headers: httpHeaders } : { headers: httpHeaders, search: params };
  }

  obterDadosCertificado() {
    if (!localStorage['token']) {
      return '';
    }
    const certificateData = JSON.parse(atob(localStorage['token'].split('.')[1]));
    return certificateData.sub;
  }

  obterInscricao() {
    if (!sessionStorage['token']) {
      return '';
    }
    const certificateData = JSON.parse(atob(sessionStorage['token'].split('.')[1]));
    return certificateData.sub.inscricao;
  }

  obterTipoInscricao() {
    if (!sessionStorage['token']) {
      return '';
    }
    const certificateData = JSON.parse(atob(sessionStorage['token'].split('.')[1]));
    return certificateData.sub.tpInscricao;
  }
  get(url: string): Observable<any> {
    return this.http.get(url, this.headers());
  }

  post(url: string, parameters: any): Observable<any> {
    return this.http.post(url, parameters, this.headers());
  }

  async postWithHeader(url: string, parameters: any, inscricao): Promise<Observable<any>> {
    return this.http.post(url, parameters, await this.headersWithTokenMaquina(inscricao));
  }

  private impressaoHeaders(token: string) {
    let httpHeaders: HttpHeaders = new HttpHeaders();

    httpHeaders = httpHeaders.set(
      'Content-Type',
      'application/json');

    httpHeaders = httpHeaders.set(
      'Authorization',
      'Bearer ' + token
    );

    return { headers: httpHeaders };
  }

  postImpressao(url: string, parameters: any, token: string): Observable<any> {
    return this.http.post(url, parameters, this.impressaoHeaders(token));
  }

}
